module.exports = __webpack_public_path__ + "img/cert.c16fbc4c.svg";